export const SEARCH_TARGET = 'search';
export const POPULAR_SEARCH_TARGET = 'popularSearchTarget';
